<template>
  <div>
    <sync-loader
      :loading="loading"
      :color="color1"
      :size="size"
      class="uk-text-center"
    ></sync-loader>

    <div
      id="messagecanvas"
      class="message map-message"
      style="max-width: 80vw"
      v-if="offline_map_display && offline_message_display"
      v-html="offline_message_text"
    ></div>
    <div
      id="mapcanvas"
      class="message nomap-message"
      style="height: 60vh; max-width: 80vw"
      v-if="!offline_map_display && offline_message_display"
      v-html="offline_message_text"
    ></div>

    <div
      class="google-map"
      :id="mapName"
      style="height: 60vh; max-width: 80vw"
      v-if="!offline_map || (offline_map && offline_map_display)"
    ></div>

    <p class="uk-hidden debug" :id="mapDebug">{{ mapsAreas }}</p>
    <p class="uk-hidden debug" :id="mapDebug2">{{ userPosition }}</p>

    <div id="main-modal-maps" uk-modal>
      <div class="uk-modal-dialog uk-modal-body">
        <h2 class="uk-modal-title">Selezione Mappa</h2>
        <div v-if="mapsAreas">
          <ul class="uk-list uk-list-striped">
            <li v-for="map in mapsAreas">
              <a v-on:click="loadMap(map)">{{ map.name }}</a>
            </li>
          </ul>
        </div>
        <div v-else>
          <sync-loader
            :loading="loading"
            :color="color1"
            :size="size"
            class="uk-text-center"
          ></sync-loader>
        </div>
        <button
          class="uk-button uk-button-default uk-modal-close"
          type="button"
        >
          Close Window
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import SyncLoader from "vue-spinner/src/SyncLoader.vue";
import axios from "axios";
import { settings } from "@/settings";

let API_SERVER = settings.API_SERVER;
let GOOGLE_MAPS_API_KEY = settings.GOOGLE_MAPS_API_KEY;

export default {
  name: "google-map",
  props: ["name", "area_id"],
  data: function () {
    return {
      debug: false,
      loading: true,
      color1: "#0099FF",
      color2: "#ABD037",
      color3: "#FF9939",
      size: "45px",
      mapName: this.name + "-map",
      mapDebug: this.name + "-debug",
      mapDebug2: this.name + "-debug2",
      markerCoordinates: [
        {
          latitude: 51.501527,
          longitude: -0.1921837,
        },
        {
          latitude: 51.505874,
          longitude: -0.1838486,
        },
        {
          latitude: 51.4998973,
          longitude: -0.202432,
        },
      ],
      vehicles: [],
      map: null,
      bounds: null,
      mapsAreas: null,
      userPosition: null,
      markers: [],
      activeAreaMap: null,
      refreshVehiclesPositionActive: false,
      refreshVehiclesPositionTimer: null,
      weekdaysnames: [
        "lunedi",
        "martedi",
        "mercoledi",
        "giovedi",
        "venerdi",
        "sabato",
        "domenica",
      ],
      userPositionMarker: null,
      offline_map: false,
      offline_map_display: false,
      offline_message_display: false,
      offline_message_text: "",
    };
  },
  methods: {
    load_script() {
      let self = this;
      let loaded = false;
      try {
        let pos_test = new google.maps.LatLng(1, 1);
        loaded = true;
        this.loadedscript_loadmap();
        return;
      } catch (e) {}

      return new Promise((resolve, reject) => {
        // if script is already loading via another component
        if (self.is_script_loading) {
          // Resolve when the other component has loaded the script
          this.$root.$on("script_loaded", resolve);
          return;
        }

        let script = document.createElement("script");
        let gmapsurl = "https://maps.googleapis.com/maps/api/js?key=";

        gmapsurl += GOOGLE_MAPS_API_KEY;
        gmapsurl += "&libraries=geometry";

        script.setAttribute("src", gmapsurl);
        script.async = true;

        this.$root.$emit("loading_script");

        script.onload = () => {
          /* emit to global event bus to inform other components
           * we are already loading the script */
          this.$root.$emit("script_loaded");
          this.loadedscript_loadmap();
          resolve();
        };

        document.head.appendChild(script);
      });
    },
    loadedscript_loadmap() {
      google.maps.Polygon.prototype.my_getBounds = function () {
        var bounds = new google.maps.LatLngBounds();
        this.getPath().forEach(function (element, index) {
          bounds.extend(element);
        });
        return bounds;
      };

      //console.log(this.$route.query.debug);
      if (this.$route.query.debug == "1234") {
        this.debug = true;
      }

      /*if (navigator.geolocation) {
            var self = this;
            navigator.geolocation.getCurrentPosition(self.loadMaps, function() {
              console.log("user pos error 1");
              self.loadMaps(0);
            });
          } else {
            console.log("user pos error 2");
            this.loadMaps(0);
          }*/
      //console.log(this.area_id);
      //console.log("its me");
      if (this.area_id != null) {
        this.activeAreaMap = this.area_id;
        //console.log("this.activeAreaMap is not null");
        //console.log(this.area_id);
        this.loadMaps(0);
      } else {
        this.loadMaps(0);
      }
    },
    unloader: function () {
      this.refreshVehiclesPositionActive = false;
      clearInterval(this.refreshVehiclesPositionTimer);
      this.refreshVehiclesPositionTimer = null;
    },
    watchUserPosition: function () {
      console.log("watchUserPosition start");
      if (navigator.geolocation) {
        var self = this;
        navigator.geolocation.watchPosition(
          function (user_position) {
            console.log("watchUserPosition success");
            console.log(user_position);
            self.userPosition = user_position;

            const position = new google.maps.LatLng(
              self.userPosition.coords.latitude,
              self.userPosition.coords.longitude
            );

            if (self.userPositionMarker) {
              self.userPositionMarker.setPosition(position);
            } else {
              const user_marker = new google.maps.Marker({
                position,
                map: self.map,
                title: stop.name,
                icon: "/img/user.png",
              });
              user_marker.addListener("click", function () {
                infowindow.setContent(vm.getUserInfoWindow());
                infowindow.open(self.map, user_marker);
              });
              self.userPositionMarker = user_marker;
              self.map.fitBounds(self.bounds.extend(position));
            }
          },
          function (error) {
            console.log("watchUserPosition error");
            console.log(error);
          }
        );
      }
    },
    loadMapWithUserPosition: function () {
      if (navigator.geolocation) {
        var self = this;
        navigator.geolocation.getCurrentPosition(
          self.loadMapWithUserPosition_success,
          self.loadMapWithUserPosition_error
        );
      }
    },
    loadMapWithUserPosition_success: function (user_position) {
      console.log("loadMaps with user_position");
      console.log(user_position);
      this.loadMaps(user_position);
    },
    loadMapWithUserPosition_error: function () {
      console.log("loadMaps with user_position error");
    },
    getWeeklyTimingMessage: function (weekly_timing) {
      let html = "";
      weekly_timing.forEach((timing, i) => {
        html += "<h5>" + this.weekdaysnames[i] + "</h5>";
        html += this.getDayTimingMessage(timing.on);
      });
      return html;
    },
    getDayTimingMessage: function (timing) {
      let html = "<ul>";
      //console.log(timing);
      timing.forEach((slot) => {
        //console.log(slot);
        html += "<li>dalle " + slot.start + " alle " + slot.end + "</li>";
      });
      html += "</ul>";
      return html;
    },
    getUserInfoWindow: function () {
      let html = "";
      html += "<h3>Green-Go User</h3>";
      return html;
    },
    getStopInfoWindow: function (stop, route, area) {
      let route_timetable = null;
      let route_is_on = true;
      let timing_today = "";

      let html = "";
      html += "<h3>" + stop.name + "</h3>";

      try {
        route_timetable = JSON.parse(route.timetable);

        var d = new Date();
        var weekly_day_today = d.getDay();
        if (weekly_day_today == 0) {
          weekly_day_today = 7;
        }
        weekly_day_today -= 1;

        timing_today = route_timetable.weekly_timing[weekly_day_today].on;

        //console.log(timing_today);
      } catch (e) {
        return html;
      }

      if (route_is_on) {
        html += "<h4>" + route_timetable.service_on_message + "</h4>";

        html += route_timetable.service_description_message.replace(
          /\n/g,
          "<br />"
        );
        //html += this.getDayTimingMessage(timing_today);
        //html += this.getWeeklyTimingMessage(route_timetable.weekly_timing);
      }

      return html;
    },
    getVehicleInfoWindow: function (vehicle, area) {
      let html = "";
      html += "<h3>" + vehicle.name + "</h3>";

      return html;
    },
    refreshVehiclesPosition: function () {
      //console.log('refreshVehiclesPosition active area ' + this.activeAreaMap.id + ' refreshVehiclesPositionActive ' + this.refreshVehiclesPositionActive);

      let vm = this;

      axios
        .get(
          API_SERVER +
            "/_/custom/greengobus/routes/getvehicles_v2/" +
            this.activeAreaMap.id
        )
        .then((response) => {
          //console.log(response.data.data);

          response.data.data.forEach((vehicle) => {
            let lalo = new google.maps.LatLng(
              vehicle.last_position_lat,
              vehicle.last_position_lon
            );

            if (vehicle.tracker_code && vm.vehicles[vehicle.tracker_code]) {
              vm.vehicles[vehicle.tracker_code].setPosition(lalo);
            } else {
              //console.log("error in refresh setPosition trcode:" + vehicle.tracker_code);
              //console.log(vm.vehicles);
              //console.log(vehicle.tracker_code);
              //console.log(vm.vehicles[vehicle.tracker_code]);
            }

            if (this.refreshVehiclesPositionActive == false) {
              this.refreshVehiclesPositionActive = true;

              this.refreshVehiclesPositionTimer = setInterval(function () {
                vm.refreshVehiclesPosition();
              }, 5000);
            }
          });
        });
    },
    loadRoutes: function (area, routes) {
      //console.log("loadRoutes");
      //console.log(area);

      this.activeAreaMap = area;

      let area_map_center_data = JSON.parse(area.map_center);
      let area_map_style = JSON.parse(area.style);

      this.bounds = new google.maps.LatLngBounds();
      const element = document.getElementById(this.mapName);
      let mapCenter = new google.maps.LatLng(
        area_map_center_data.lat,
        area_map_center_data.lng
      );
      const options = {
        center: mapCenter,
        styles: area_map_style,
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
      };

      this.map = new google.maps.Map(element, options);

      let infowindow = new google.maps.InfoWindow({
        content: "loading...",
      });

      if (this.debug) {
        let safe_areas_in = JSON.parse(area.safe_area_in_v2);
        for (let ix in safe_areas_in) {
          let sa = safe_areas_in[ix];

          var rectangle = new google.maps.Rectangle({
            strokeColor: "#3670b1",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#3670b1",
            fillOpacity: 0.35,
            map: this.map,
            bounds: {
              north: sa[0][0],
              west: sa[0][1],
              south: sa[1][0],
              east: sa[1][1],
            },
          });
        }

        let safe_areas_out = JSON.parse(area.safe_area_out_v2);
        for (let ix in safe_areas_out) {
          let sa = safe_areas_out[ix];

          var rectangle = new google.maps.Rectangle({
            strokeColor: "#FF0000",
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: "#FF0000",
            fillOpacity: 0.35,
            map: this.map,
            bounds: {
              north: sa[0][0],
              west: sa[0][1],
              south: sa[1][0],
              east: sa[1][1],
            },
          });
        }
      }

      let vm = this;
      let route_service_on = false;
      let route_service_off_message = "";

      routes.forEach((route) => {
        let ttb = JSON.parse(route.timetable);

        let date = new Date();
        let weekday = date.getDay();

        if (weekday == 0) {
          weekday = 7;
        }
        weekday--;

        let today_timing = ttb.weekly_timing[weekday];

        for (let interval of today_timing.on) {
          let now_h = date.getHours();
          let now_m = date.getMinutes();

          let is_h = interval.start.split(":")[0];
          let is_m = interval.start.split(":")[1];

          let ie_h = interval.end.split(":")[0];
          let ie_m = interval.end.split(":")[1];

          if (
            (now_h > is_h || (now_h == is_h && now_m >= is_m)) &&
            (now_h < ie_h || (now_h == ie_h && now_m <= ie_m))
          ) {
            route_service_on = true;
          } else {
          }
        }

        if (route_service_on == false) {
          route_service_off_message += ttb.service_off_message + "\n";
        }

        if (route.draw_line_coordinates) {
          let my_path = [];
          let jroute_draw_line_coordinates = JSON.parse(
            route.draw_line_coordinates
          );

          jroute_draw_line_coordinates.forEach((coord) => {
            my_path.push(new google.maps.LatLng(coord.lat, coord.lng));
          });

          let flightPath = new google.maps.Polyline({
            path: my_path,
            strokeColor: route.draw_line_color_active,
            strokeOpacity: 1.0,
            strokeWeight: 3,
          });

          flightPath.setMap(this.map);
        }

        let filter = "";
        filter += "?filter[route][eq]=" + route.id;

        axios
          .get(API_SERVER + "/_/custom/greengobus/routes/getstops/" + route.id)
          .then((response) => {
            response.data.data.forEach((stop) => {
              let stop_pos = JSON.parse(stop.position);
              const position = new google.maps.LatLng(
                stop_pos.lat,
                stop_pos.lng
              );
              const marker = new google.maps.Marker({
                position,
                map: this.map,
                title: stop.name,
                zIndex: 30,
                icon: {
                  url: "/img/sfera_blu.png",
                  // This marker is 20 pixels wide by 32 pixels high.
                  // The origin for this image is (0, 0).
                  origin: new google.maps.Point(0, 0),
                  // The anchor for this image is the base of the flagpole at (0, 32).
                  anchor: new google.maps.Point(16, 28),
                  scaledSize: new google.maps.Size(32, 32),
                },
              });
              marker.addListener("click", function () {
                infowindow.setContent(vm.getStopInfoWindow(stop, route, area));
                infowindow.open(this.map, marker);
              });
              this.markers.push(marker);
              this.map.fitBounds(this.bounds.extend(position));
            });
          });
      });

      if (route_service_on) {
        axios
          .get(
            API_SERVER + "/_/custom/greengobus/routes/getvehicles/" + area.id
          )
          .then((response) => {
            response.data.data.forEach((vehicle) => {
              let lalo = new google.maps.LatLng(
                vehicle.last_position_lat,
                vehicle.last_position_lon
              );

              let cardDir = vehicle.cardinal_dir === "E" ? "E" : "W";
              // bus.dir_angle = "-23";
              if (vehicle.dir_angle) {
                const ang = parseInt(vehicle.dir_angle);
                if (ang < -165 || ang >= 115) {
                  cardDir = "W";
                } else if (ang <= -90) {
                  cardDir = "S";
                } else if (ang < -75) {
                  cardDir = "E";
                } else if (ang < 25) {
                  cardDir = "E";
                } else if (ang < 115) {
                  cardDir = "N";
                }
              }

              let vehicle_marker = new google.maps.Marker({
                position: lalo,
                map: this.map,
                title: vehicle.name,
                zIndex: 60,
                icon: {
                  scaledSize: new google.maps.Size(72, 58),
                  anchor: new google.maps.Point(16, 28),
                  url: "/img/greengo_" + cardDir + ".png",
                },
              });

              vehicle_marker.addListener("click", function () {
                infowindow.setContent(vm.getVehicleInfoWindow(vehicle, area));
                infowindow.open(this.map, vehicle_marker);
              });

              vehicle_marker.setMap(this.map);

              this.vehicles[vehicle.tracker_code] = vehicle_marker;
            });
          });

        this.offline_map = false;
        this.offline_map_display = area.show_map_when_not_active;

        this.refreshVehiclesPosition();
      } else {
        this.offline_map = true;
        this.offline_map_display = area.show_map_when_not_active;
        this.offline_message_display = true;
        this.offline_message_text = "<h3>Servizi Non Attivi</h3>";
        this.offline_message_text += route_service_off_message.replace(
          /\n/g,
          "<br />"
        );

        //console.log(route_service_off_message);
      }
      //TODO verificare che sia il posto giusto per chiudere il loading
      this.loading = false;
    },
    loadMap: function (area) {
      var modal = UIkit.modal("#main-modal-maps");
      modal.hide();

      axios
        .get(
          API_SERVER +
            "/_/custom/greengobus/routes/linesroutes_by_area/" +
            area.id
        )
        .then((response) => {
          this.loadRoutes(area, response.data.data);
        });
    },
    loadMapView: function (map_data) {
      this.mapsAreaActive = null;
      this.mapsAreas = map_data;

      //console.log(this.mapsAreas.length > 0);
      //console.log(this.mapsAreas.length);

      if (this.mapsAreas.length > 0 && this.mapsAreas.length == 1) {
        this.loadMap(this.mapsAreas[0]);
      } else if (!this.userPosition) {
        // if NOT user position, we display modal select area.
        let modal = UIkit.modal("#main-modal-maps");
        modal.show();
      } else {
        // we load the map closer to the user position.
        this.mapsAreas.forEach((area) => {
          var area_coords = JSON.parse(area.area_activation);

          var area_activation = new google.maps.Polygon({ paths: area_coords });

          area.center = area_activation.my_getBounds().getCenter();

          var userpos = new google.maps.LatLng(
            this.userPosition.coords.latitude,
            this.userPosition.coords.longitude
          );

          var inside = google.maps.geometry.poly.containsLocation(
            userpos,
            area_activation
          );

          if (inside) {
            area.userInside = true;
            this.mapsAreaActive = area;
            //console.log("user position inside area " );
          } else {
            area.userInside = false;
            //console.log("user position outside area " );
          }

          var service = new google.maps.DistanceMatrixService();
          service.getDistanceMatrix(
            {
              origins: [userpos],
              destinations: [area.center],
              travelMode: "DRIVING",
              //transitOptions: TransitOptions,
              //drivingOptions: DrivingOptions,
              //unitSystem: UnitSystem,
              avoidHighways: false,
              avoidTolls: false,
            },
            function (response, status) {
              area.UserDistanceResponse = response;

              if (
                response.rows.length > 0 &&
                response.rows[0].elements.length > 0
              ) {
                if (response.rows[0].elements[0].status != "ZERO_RESULTS") {
                  area.UserDistance =
                    response.rows[0].elements[0].duration.value;
                } else {
                  area.UserDistance = false;
                }
              } else {
                area.UserDistance = false;
              }
            }
          );
        });

        //sort area by user distance (close first)
        this.mapsAreas = this.mapsAreas.sort(function (a, b) {
          if (a.UserDistance != false || a.UserDistance < b.UserDistance) {
            return -1;
          }
          if (a.UserDistance > b.UserDistance) {
            return 1;
          }
          return 0;
        });

        this.loadMap(this.mapsAreas[0]);
      }
    },
    loadMaps: function (user_position) {
      if (user_position != null) {
        this.userPosition = user_position;
      } else {
        console.log("not ready to start maps without user location");
        return;
      }

      if (this.area_id != null && this.area_id > 0) {
        axios
          .get(
            API_SERVER +
              "/_/items/areas?limit=10&filter[id][eq]=" +
              this.area_id
          )
          .then((response) => {
            this.loadMapView(response.data.data);
          });
      } else {
        let status_filter = "published";
        if (this.debug) {
          status_filter += ",debug";
        }

        axios
          .get(
            API_SERVER +
              "/_/items/areas?limit=10&status=" +
              status_filter +
              "&filter[show_in_main_area_list][eq]=1"
          )
          .then((response) => {
            this.loadMapView(response.data.data);
          });
      }
    },
  },
  computed: {},
  created() {
    /*let gmapsScript = document.createElement('script');
    let gmapsApiurl = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBYbAhzukcfYFJjjDNDIy1q3fcwvjrEONI&libraries=geometry";
    gmapsScript.setAttribute('src', gmapsApiurl);
    document.head.appendChild(gmapsScript);*/

    document.addEventListener("beforeunload", this.unloader);
  },
  mounted: function () {
    this.load_script();
  },
  components: {
    SyncLoader,
  },
};
</script>
<style>
div#mapcanvas {
  width: 100%;
  height: 600px;
  max-height: 100%;
  max-width: 100%;
  min-height: 450px;
  margin: auto;
  background-color: #e5e5e5;
  text-align: center;
}

div#messagecanvas {
  width: 100%;
  max-width: 100%;
  margin: auto;
  background-color: #e5e5e5;
  text-align: center;
}

.message h3 {
  margin-top: 1rem;
}

div#mapcanvas.message,
.message h3,
div#messagecanvas.message {
  color: #0099ff !important;
}

div#messagecanvas {
  margin-bottom: 1rem;
}

.google-map {
  width: 100%;
  height: 600px;
  margin: 0 auto;
  background: gray;
}
</style>
